import { z } from 'zod'

export const ResponsibleMedicalRecordLink = z.object({
  uuid: z.string()
})
export type ResponsibleMedicalRecordLink = z.infer<
  typeof ResponsibleMedicalRecordLink
>
